import { useEffect } from 'react';

/**
 * Warm the browser cache for image URLs.
 * Safe on static hosting — uses plain Image() requests, no bundler magic.
 * @param {string[]} urls
 * @param {{ enabled?: boolean, urgent?: boolean }} [options]
 */
export function usePreloadImages(urls, { enabled = true, urgent = false } = {}) {
  useEffect(() => {
    if (!enabled || !urls?.length) return;

    let cancelled = false;

    const preload = () => {
      if (cancelled) return;
      urls.forEach((url) => {
        if (!url) return;
        const img = new Image();
        img.decoding = 'async';
        if (urgent) img.fetchPriority = 'high';
        img.src = url;
      });
    };

    if (urgent) {
      preload();
      return () => {
        cancelled = true;
      };
    }

    if (typeof window.requestIdleCallback === 'function') {
      const id = window.requestIdleCallback(preload, { timeout: 1500 });
      return () => {
        cancelled = true;
        window.cancelIdleCallback(id);
      };
    }

    const id = window.setTimeout(preload, 80);
    return () => {
      cancelled = true;
      window.clearTimeout(id);
    };
  }, [enabled, urgent, urls]);
}
